import React from "react";
import { Box, Container, Typography, Button } from "@mui/material";
import { Link } from "react-router-dom";

const NotFoundPage = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: "#FFF9F0", // Your brand background
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        py: 6,
      }}
    >
      <Container maxWidth="md">
        <Box
          sx={{
            backgroundColor: "#fff",
            borderRadius: "28px",
            p: { xs: 4, md: 8 },
            textAlign: "center",
            boxShadow: "0px 8px 40px rgba(0, 0, 0, 0.04)",
            border: "2px solid #F7F1E8",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 3,
          }}
        >
          {/* Visual Element - Using a custom styled 404 text or an asset */}
          <Typography
            sx={{
              fontSize: { xs: "80px", md: "120px" },
              fontFamily: "Test Domaine Display, serif",
              fontWeight: 900,
              lineHeight: 1,
              color: "#333333",
              opacity: 0.1,
              mb: -4, // Overlap effect
            }}
          >
            404
          </Typography>

          <Box
            component="img"
            src="/assets/mask.svg" // Reusing your existing asset for consistency
            alt="Not Found"
            sx={{
              width: "100%",
              maxWidth: "200px",
              height: "auto",
              mb: 2,
            }}
          />

          <Typography
            sx={{
              fontSize: { xs: "32px", md: "48px" },
              fontFamily: "Test Domaine Display, serif",
              fontWeight: 700,
              color: "#000",
              lineHeight: 1.2,
            }}
          >
            Lost in the Mountains?
          </Typography>

          <Typography
            sx={{
              fontSize: { xs: "18px", md: "20px" },
              fontFamily: "Elza, sans-serif",
              color: "#666",
              maxWidth: "500px",
              lineHeight: 1.6,
            }}
          >
            The page you are looking for (or the referral link you used) doesn't
            exist or has expired. Let's get you back on track.
          </Typography>

          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              gap: 2,
              mt: 2,
              width: "100%",
              justifyContent: "center",
            }}
          >
            <Button
              component={Link}
              to="/"
              sx={{
                background: "linear-gradient(0deg, #333333, #333333)",
                color: "#fff",
                textTransform: "none",
                fontSize: "18px",
                fontWeight: 600,
                px: 6,
                py: 2,
                borderRadius: "50px",
                boxShadow: "0px 4px 24px rgba(0, 0, 0, 0.1)",
                "&:hover": {
                  background: "#000",
                },
              }}
            >
              Back to Home
            </Button>

            <Button
              component={Link}
              to="/register"
              sx={{
                background: "transparent",
                color: "#333",
                textTransform: "none",
                fontSize: "18px",
                fontWeight: 600,
                px: 6,
                py: 2,
                borderRadius: "50px",
                border: "2px solid #333",
                "&:hover": {
                  background: "#333",
                  color: "#fff",
                },
              }}
            >
              Register Now
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default NotFoundPage;